import { PATH_IMAGES } from '../routes/paths';

export const photoURL = ((id: string) => `${PATH_IMAGES}/blog/${id}.webp`)